import {TweenMax, Power3} from 'gsap';

export class PushToScroll {
    private readonly obj = document.querySelectorAll(".js-scroll-to");
    private readonly targets = document.querySelectorAll(".js-scroll-to-target");
    private current = null;

    constructor() {
        if (this.obj.length > 0) {
            this.init();
        }

        if (this.targets.length > 0) {
            this.checkActive();

            // this is because of aos.js
            setTimeout(() => {
                this.checkActive();
            }, 900);

            setTimeout(() => {
                this.checkActive();
            }, 1000);

            document.addEventListener('scroll', () => {
                this.checkActive();
            });
        }
    }

    private init(): void {
        const defaultOffset = 0;
        // @ts-ignore
        for (let item of this.obj) {
            const target = document.querySelector(`${item.dataset.target}`);
            let offset = item.dataset.offset;

            if (!target) {
                return;
            }

            if (!offset) {
                offset = defaultOffset;
            }

            item.addEventListener('click', () => {
                // @ts-ignore
                TweenMax.to([document.documentElement, document.body], 1, {
                    // @ts-ignore
                    scrollTop: -document.body.getBoundingClientRect().y + target.getBoundingClientRect().y + offset,
                    ease: Power3.easeOut
                });
            });
        }
    }

    private checkActive(): void {
        // @ts-ignore
        for (let item of this.targets) {
            let initItem = document.querySelector(`[data-target="#${item.id}"]`);

            if (initItem === null) {
                return;
            }

            if (item.getBoundingClientRect().top < 50 &&
                item.offsetHeight > Math.abs(parseInt(item.getBoundingClientRect().top)) &&
                item.id !== this.current) {
                // @ts-ignore
                initItem.classList.add('is-active');
            } else if (item.id !== this.current) {
                initItem.classList.remove('is-active');
            }

            if (item.getBoundingClientRect().top < 50 &&
                item.offsetHeight > Math.abs(parseInt(item.getBoundingClientRect().top))) {
                this.current = item.id;
            }
        }
    }
}
